
import simple_select from './simple_select';
import direct_select from './direct_select';
import draw_point from './draw_point';
import draw_polygon from './draw_polygon';
import draw_line_string from './draw_line_string';
import SRMode from "./SRMode";

export default {
  simple_select,
  direct_select,
  draw_point,
  draw_polygon,
  draw_line_string,
  SRMode,
};
